import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import { Box, xcss } from '@atlaskit/primitives';
import Lozenge from '@atlaskit/lozenge';
import type { UpdateType } from '@app/app-updates/src/schema';

const lozengeWrapperStyles = xcss({
  display: 'inline-flex',
});

const messages = defineMessages({
  high: {
    id: 'appUpdatesTable.impactRating.high',
    defaultMessage: 'High',
    description: 'High impact rating label',
  },
  medium: {
    id: 'appUpdatesTable.impactRating.medium',
    defaultMessage: 'Medium',
    description: 'Medium impact rating label',
  },
  low: {
    id: 'appUpdatesTable.impactRating.low',
    defaultMessage: 'Low',
    description: 'Low impact rating label',
  },
});

export interface UpdateImpactRatingProps {
  impactRating?: UpdateType['impactRating'];
}

export const UpdateImpactRating: React.FC<UpdateImpactRatingProps> = ({
  impactRating,
}) => {
  const { formatMessage } = useIntl();

  if (!impactRating) {
    return null;
  }

  switch (impactRating) {
    case 'HIGH':
      return (
        <Box xcss={lozengeWrapperStyles}>
          <Lozenge appearance="removed" isBold>
            {formatMessage(messages.high)}
          </Lozenge>
        </Box>
      );
    case 'MEDIUM':
      return (
        <Box xcss={lozengeWrapperStyles}>
          <Lozenge appearance="moved" isBold>
            {formatMessage(messages.medium)}
          </Lozenge>
        </Box>
      );
    case 'LOW':
      return (
        <Box xcss={lozengeWrapperStyles}>
          <Lozenge appearance="success" isBold>
            {formatMessage(messages.low)}
          </Lozenge>
        </Box>
      );
    default:
      return null;
  }
};
